import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import CalendarComponent from "../../React_Components/CalendarComponen";
import TrackerButtons from "../Tracker_Common/TrackerButtons";
import { FaEdit, FaTrash } from 'react-icons/fa'; // React Icons for edit
import ErrorModal from "../../Security/ErrorModal";
import { toast } from "react-toastify";
import RemainderModal from "../Tracker_Common/Remainder";
import { Endpoints } from "../../../Global/Endpoints";
import { useTranslation } from 'react-i18next';
import MiraDataSync from "../../Mira/MiraDataSync";
import SyncMiraDevice from "../../Mira/SyncMiraDeviceModal";
const Fertility =()=>
{
    const { t } = useTranslation();
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [currentMonth, setCurrentMonth] = useState(new Date());
    const [remainders, setRemainders] = useState([]);
    const [notes, setNotes] = useState([]);
    const [reminderList, setReminderList] = useState([]);
    const [editData, setEditData] = useState(null);
    const email = useSelector((state) => state.email.email);
    const userInfo = useSelector((state) => state.userData);
    const [miraConsent, setMiraConsent] = useState(null);
    const [showMiraModal, setShowMiraModal] = useState(false);
    const [showSyncMiraDevice, setShowSyncMiraDevice] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState(false);
    const [deletingReminder, setDeletingReminder] = useState(null);
    const [isModalOpen, setModalOpen] = useState(false);
    const [fertilityData,setFertilityData] = useState({currentCycle: [], nextCycle: [],monthCycle: [],ovulation:[]});
    const token = localStorage.getItem("AccessToken");
    const navigate=useNavigate();
    const deviceType = "PatientPortal";

    const ssoData = useSelector((state) => state.sso.ssoUserData);
    const isHighmarkPortal = ssoData?.Portal === "Highmark";

    const fetchMenstrualCycleData = async (date) => {
      const currentDate = date.toLocaleDateString("en-US");
      const params = { EmailID: email, Date: currentDate,DeviceType: deviceType };

    
  setLoading(true);
      try {
        const response = await axios.post(
         Endpoints.LoadMenstrualCycleCalendarData,
          `_Params=${encodeURIComponent(JSON.stringify(params))}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`,
            },
          }
        );
  
        if (response.data) {
          setRemainders(response.data.ReminderDate ? response.data.ReminderDate.split(",") : []);
          setNotes(response.data.EventDate ? response.data.EventDate.split(",") : []);
          const parseCycleData = (cycleString) => {
            // Split the string into an array of dates
            const dates = cycleString ? cycleString.split(",") : [];
            // Check if there are dates to set start and end
            if (dates.length > 0) {
                return [{ start: dates[0], end: dates[dates.length - 1] }];
            }
            return [];
        };

        setFertilityData({
          currentCycle: parseCycleData(response.data.CurrentCycle),
          nextCycle: parseCycleData(response.data.NextCycle),
          monthCycle: parseCycleData(response.data.MonthlyCycle),
          ovulation: parseCycleData(response.data.OvulationCycle)
      });
        }
      } catch (error) {
        console.error("Error fetching menstrual cycle data:", error);
      } finally {
      setLoading(false);  
    }
    };
    const fetchReminders = async (date) => {
      const formattedDate = date.toLocaleDateString("en-US");
      const params = { EmailID: email, Date: formattedDate,DeviceType: deviceType };
  setLoading(true);
      try {
        const response = await axios.post(
          Endpoints.LoadReminderEventData,
          `_Params=${encodeURIComponent(JSON.stringify(params))}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`,
            },
          }
        );
  
        if (response.data && response.data.Reminders) {
          const mappedReminders = response.data.Reminders.map(reminder => ({
            ReminderID: reminder.ReminderID,
            ReminderTitle: reminder.ReminderTitle,
            StartTime: new Date(reminder.StartTime), // Ensure this is a Date object
            EndTime: new Date(reminder.EndTime), // Ensure this is a Date object
          }));
          setReminderList(mappedReminders);
        }
      } catch (error) {
        console.error("Error fetching reminders:", error);
      } finally {
      setLoading(false);  }
    };

    useEffect(() => {
      if (typeof window !== "undefined") {
      window.resetCalendarGlobals?.();
    }
    }, []);
    
    useEffect(() => {
      const handleMaybeLaterEvent = () => {
        setShowMiraModal(false);
      };

      window.addEventListener("miraMaybeLaterClicked", handleMaybeLaterEvent);

      return () => {
        window.removeEventListener("miraMaybeLaterClicked", handleMaybeLaterEvent);
      };
    }, []);

    useEffect(() => {
      fetchMenstrualCycleData(currentMonth);
      fetchReminders(selectedDate);
    }, [currentMonth, selectedDate, email, token]);
  
    useEffect(() => {
      fetchReminders(selectedDate);
    }, [selectedDate, email, token]);
  
    const handleDateSelect = (date) => {
      setSelectedDate(date);
    };
  
    const handleMonthChange = (firstDayOfMonth) => {
      setCurrentMonth(firstDayOfMonth);
    };
  
    const getConfig = () => ({
      type: "fertility",
      cycleData:fertilityData,
      onDateSelect: handleDateSelect,
      onMonthChange: handleMonthChange,
      remainders,
      notes,
    });

    const handleDeleteClick = (reminder) => {
      setDeletingReminder(reminder);
      setShowDeleteConfirmationModal(true);
    };

    const confirmDelete = async () => {
      setShowDeleteConfirmationModal(false);

      if (!deletingReminder?.ReminderID) return;

      const payload = {
        ReminderID: deletingReminder.ReminderID,
        EmailID: email,
        DeviceType: deviceType,
      };

      try {
        const response = await axios.post(
          Endpoints.DeleteReminder,
          `_Params=${encodeURIComponent(JSON.stringify(payload))}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data?.Result === "1") {
          setTimeout(() => {
            toast.success(t("reminderdeletemessage"));
          }, 500);
          setReminderList(prev =>
            prev.filter(r => r.ReminderID !== deletingReminder.ReminderID)
          );
        } else {
          toast.error("Failed to delete reminder");
        }
      } catch (error) {
        console.error(error);
        toast.error("An error occurred while deleting the reminder.");
      } finally {
        setDeletingReminder(null);
      }
    };
  
    const hasValidReminders = reminderList.some(reminder =>
      reminder.ReminderID && reminder.ReminderTitle && reminder.StartTime && reminder.EndTime
    );
  
    const handleEditClick = (reminder) => {
      console.log(selectedDate)
      if(selectedDate >= new Date() || selectedDate.toDateString() === new Date().toDateString())
      {
        setEditData({
          isEdit: true,
          reminderId: reminder.ReminderID,
          reminderDate: selectedDate
        });
        setModalOpen(true);
      }
    };

    useEffect(() => {
  const fetchMiraConsent = async () => {
    if (!email || !userInfo?.userData.AppUserId) return;
    const params = { EmailID: email, AppUserId: userInfo.userData.AppUserId, DeviceType: deviceType };
    setLoading(true);
    try {
      const response =  await axios.post(
        Endpoints.LoadMiraDataSyncConsent,
        `_Params=${encodeURIComponent(JSON.stringify(params))}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );
       if (response.data) {
        setMiraConsent(response.data);
        if (!response.data.Consent || !response.data.Consent.trim()) {
            setShowMiraModal(true);
          } else if (response.data.Consent === "O") {
            // hide mira button
          }
      }
    } catch (error) {
      console.error("Error fetching Mira Data Sync Consent:", error);
    } finally {
      setLoading(false);  
    }
  };
  fetchMiraConsent();
}, [email, userInfo?.userData.AppUserId]);
  
    const closeModal = () => {
      setModalOpen(false);
      setEditData(null);
      handleModalClose();
    };
  
    const handleModalClose = () => {
      fetchMenstrualCycleData(currentMonth);
      fetchReminders(selectedDate);
    };
    const handleBackClick = () => {
      navigate(-1); // Redirects to the home page
    };

    // Add a handler for the Mira button
    const handleMiraButtonClick = () => {
      setShowSyncMiraDevice(true);
    };

    if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }

return (
    <>
 

 
      {isHighmarkPortal ? (
<div className="col-md-6 mt-4 inner-page-heading-wrapper fertility-tracker-heading">
<div className="d-flex align-items-center">
<button className="win-back-btn" onClick={handleBackClick}>
<span>
<i className="bi bi-chevron-left"></i>
</span>
</button>
<h2 className="page-headingg ms-2 mb-0">{t('FertilitySymptomTracker')}</h2>
</div>
    {/* Text below heading */}
<p className="page-subtextt text-muted mt-1">
      {t('Track your daily fertility symptoms and monitor your progress.')}
</p>
</div>
) : (
<div className="col-md-12 mt-4 inner-page-heading-wrapper fertility-tracker-heading">
<div className="d-flex align-items-center">
<button className="win-back-btn" onClick={handleBackClick}>
<span>
<i className="bi bi-chevron-left"></i> {t('Back')}
</span>
</button>
<h2 className="page-heading ms-2 mb-0">{t('FertilitySymptomTracker')}</h2>
</div>
    {/* Text below heading */}
 {miraConsent?.Consent !== "O" && ( <div className="non-wrapping-text" >

      <p className="page-subtext text-muted mt-3" style={{ textAlign:"justify",wordWrap:"break-word" }}> 
        
    {t('fertilitytext')}
  
      </p>
      <p  style={{ textAlign: "justify", fontSize: "18px", fontWeight: "600", marginBottom: "8px" , paddingTop:"10px"}}>
    {t('seetrendsheading')}
  </p>
  <p className="text-muted" style={{ textAlign: "justify", fontSize: "16px", marginBottom: "0px" }}>
    {t('seetrendstext')}
  </p>
      </div>
    )}
</div>
)}

    {/* <div className="col-md-6 mt-4 inner-page-heading-wrapper">
        <button className="win-back-btn" onClick={handleBackClick}><span><i class='bi bi-chevron-left'></i> {t('back')}</span></button>
        <h2 className="page-heading">{t("FertilitySymptomTracker")}</h2>
      </div> */}
      <div className="col-md-12 mt-2 d-flex flex-column justify-content-center align-items-center fertility-tracker-buttons-wrapper" >
        {/* <button className="win-back-btn mt-4 me-2" onClick={handleBackClick}><span><i class='bi bi-chevron-left'></i> Back</span></button> */}
      {miraConsent?.Consent !== "O" && (
        <div className="d-flex flex-column fertility-tracker-buttons-wrapper" >
    

  
</div>
  )}
      <div className="col-md-6 mt-2 mb-3 d-flex justify-content-center flex-sm-row flex-column align-items-center fertility-tracker-buttons-wrapper" >
        {/* <button className="win-back-btn mt-4 me-2" onClick={handleBackClick}><span><i class='bi bi-chevron-left'></i> Back</span></button> */}
       
    <TrackerButtons
          isPastDate={selectedDate < new Date()}
          isToday={selectedDate.toDateString() === new Date().toDateString()}
          isFutureDate={selectedDate > new Date()}
          trackerType="fertility"
          selectedDate={selectedDate}
          onCloseModalCallback={handleModalClose}
          showEditCycle={true} /* No Edit Cycle for Pregnancy */
          showTrends={false} /* Show Trends for Pregnancy */
          isEditMode={true}
          onMiraClick={handleMiraButtonClick}
          miraConsent={miraConsent}
        />
      </div>
      </div>
      
      <div className="col-md-4 fertility-tracker">
        <CalendarComponent config={getConfig()} />
      </div>
        <div className="col-md-2"></div>
      <div className="col-md-6 mt-5 fertility-tracker-remainders">
        <h3 className="page-heading-bold remainders-heading">{t("MyReminders")}</h3>
        <div className="reminders-wrapper mt-md-5">
          {hasValidReminders ? (
            reminderList.sort((a, b) => a.StartTime - b.StartTime).map((reminder, index) => (
              <div key={index} className="reminder-card">
                <h4 className="reminder-appointment-name">{reminder.ReminderTitle}</h4>
                <h4 className="reminder-appointment-datetime">{t("StartDate")}: {(() => {
                  // Format date as mm/dd/yyyy
                  const dateObj = reminder.StartTime;
                  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                  const date = String(dateObj.getDate()).padStart(2, '0');
                  const year = dateObj.getFullYear();
                  const formattedDate = `${month}/${date}/${year}`;
                  // Check if time is 00:00:00
                  const hours = dateObj.getHours();
                  const minutes = dateObj.getMinutes();
                  const seconds = dateObj.getSeconds();
                  if (hours === 0 && minutes === 0 && seconds === 0) {
                    // Show only date
                    return formattedDate;
                  } else {
                    // Show date and time
            const formattedTime = dateObj.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });                    
             return `${formattedDate}, ${formattedTime}`;
                }
                })()}</h4>
                  <FaEdit onClick={() => handleEditClick(reminder)} className="reminder-edit-icon" />
                  <FaTrash onClick={() => handleDeleteClick(reminder)} className="reminder-delete-icon" />
              </div>
            ))
          ) : (
            <div className="no-reminders-set mb-3">{t("Youhavenotsetanyreminders")}</div>
          )}
        </div>
      </div>
      
      <RemainderModal 
        isOpen={isModalOpen} 
        onClose={closeModal} 
        reminderId={editData?.reminderId} 
        reminderDate={editData?.reminderDate} 
        isEdit={editData?.isEdit} 
        onSave={() => fetchReminders(selectedDate)}
      />

      <MiraDataSync
        isOpen={showMiraModal}
        onClose={() => setShowMiraModal(false)}
        email={email}
        userInfo={userInfo}
        deviceType={deviceType}
        miraLoginURL={miraConsent?.MiraLoginURL}
        MiraLearnmore={miraConsent?.MiraLearnmore}
        token={token}
      />

      <SyncMiraDevice 
        isOpen={showSyncMiraDevice}
        onClose={() => setShowSyncMiraDevice(false)}
        email={email}
        userInfo={userInfo}
        deviceType={deviceType}
        miraConsent={miraConsent?.Consent}
        miraLoginURL={miraConsent?.MiraLoginURL}
        MiraLearnmore={miraConsent?.MiraLearnmore}
        token={token}
      />

      <ErrorModal
        show={showDeleteConfirmationModal}
        onClose={() => setShowDeleteConfirmationModal(false)}
        showConfirmButtons={true}
        message={"Are you sure you want to delete this reminder?"}
        onOkay={confirmDelete}
      />
    </>
    
)
}
export default Fertility;